import { downloadFile } from '@/utils/http/http.service';
import Http from '@/utils/http/index';

export default {
  /**
   * 还原申报明细列表
   */
  getList(params) {
    return Http.post('/collect/event/list', params);
  },

  // 上传文件
  uploadDeclarationFile(data) {
    const options = {
      headers: { 'Content-Type': 'multipart/form-data' },
    };
    return Http.post('/collect/upload', data, options);
  },

  // 获取应用列表，用于上传文件时的选项框
  getAppList() {
    return Http.get('/merchant/app/getGoodsTradeApp');
  },

  // 下载文件
  downloadFileByUrl(params) {
    return downloadFile('/collect/getFile', { params });
  },
};
